module.exports = __webpack_public_path__ + "img/messengers.74fb8d99.svg";